/* eslint-disable */
import { compose } from 'recompose';
import { connect } from 'react-redux';

import ggAuth from 'ggApp/modules/auth';

import Summary from './Summary';

const enhance = compose(
    connect(
        state => ({
            user: ggAuth.selectors.user(state),
            order: state.order.active,
            orderFetching: state.order.fetching,
        }),
        dispatch => ({ dispatch }),
    ),
);

export default enhance(Summary);
